<template>
  <div>
    <InviteShopping v-if="showInvite" @toggleInvite="showInvite = $event" />
    <div
      v-if="
        walletSummary.wallet.settings.notifications.shopping_invite_status ===
        'invited'
      "
    >
      <InviteShoppingBeta @showModal="show($event)" />
    </div>
    <base-header-page :isHorizontal="true" class="has-background-support">
      <WalletValues />
    </base-header-page>
    <div class="c-wallet__wrapper">
      <WalletLastTransactions />
    </div>
    <div
      v-if="!walletSummary.loading"
      :class="{ 'c-wallet--balance-fixed': showNavbar }"
      class="c-wallet__balance"
    >
      <p class="is-inline-flex">
        <small>Disponível para uso: </small>
        <base-reload
          label=" "
          class="has-text-white"
          v-if="walletSummary.pending"
        />
        <strong
          v-else
          :class="{ 'has-background-error': walletSummary.balance < 0 }"
          class="has-text-white"
        >
          {{ walletSummary.balance | currency }}
        </strong>
      </p>
    </div>
  </div>
</template>

<script>
import WalletLastTransactions from '@/components/Wallet/WalletLastTransactions.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import WalletValues from '@/components/Wallet/WalletValues.vue'
import InviteShoppingBeta from '@/components/Wallet/InviteShoppingBeta.vue'
import InviteShopping from '@/components/Wallet/InviteShopping.vue'

export default {
  components: {
    WalletLastTransactions,
    WalletValues,
    BaseHeaderPage,
    InviteShoppingBeta,
    InviteShopping,
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
  },

  data() {
    return {
      showNavbar: false,
      lastScrollPosition: 0,
      showInvite: false,
    }
  },

  mounted() {
    window.addEventListener('scroll', this.walletBalanceFixed)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.walletBalanceFixed)
  },

  methods: {
    walletBalanceFixed() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 300) {
        return
      }
      this.showNavbar = currentScrollPosition > this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    show(value) {
      this.showInvite = value
    },
  },
}
</script>

<style lang="scss">
.c-base-header-page__content {
  padding-top: 6px;
}

.c-wallet {
  &__wrapper {
    max-width: 768px;
    margin: 0 auto;
  }

  &__balance {
    display: none;
    padding: 0.5em 1em;
    color: $white;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    background-color: $support;

    > p {
      display: inline-flex;
      align-items: center;
    }

    .c-base-reload {
      margin-top: 0;
      margin-left: 1em;
    }
  }

  &--balance-fixed {
    display: block;
    opacity: 1;
    visibility: visible;
    z-index: 31;
    @include position(fixed, 49px, 0, auto, 0);
    @include app-shadow();
    @media (min-width: $tablet) {
      top: 60px;
    }
  }
}
</style>
